
<template>

	<mymodal ref="modal" :title="essence + '. Множественное редактирование. Сброс значений ценообразующих факторов'" ok="Применить" :reset="reset" :check="check" :submit="submit" width="675px">

		<attr_many_select :attrs="my_attrs" :attrs_visible="attrs_visible" v-model="attrs_selected" without_system without_bad/>

	</mymodal>

</template>

<script>

import api from "../../../../api"
import mymodal from "../../../widgets/modal"
import attr_many_select from "../../../widgets/attr_many_select"

export default
{
	props :
	{
		essence : String,
		attrs : Array,
		service : String
	},

	components :
	{
		mymodal,
		attr_many_select,
	},

	data()
	{
		return {
			
			my_attrs : [],
			attrs_visible : [],
			attrs_selected : [],

		}
	},

	computed :
	{
		has_oks()
		{
			return api.has_oks()
		}
	},

	methods :
	{
		check()
		{
			return this.attrs_selected.length > 0
		},

		reset()
		{
			this.my_attrs = this.attrs.filter(attr => ! attr.not_real)

			if (this.service != "cadastral_analogues_expensive")			
			{
				var possible_attrs_keys = new Set([ "attrs.Segment", "attrs.Evaluating_Using_Code", "attrs.Type_Of_Using_Code" ])

				if(api.has_oks())
				{
					possible_attrs_keys.add("attrs.functional_group")
					possible_attrs_keys.add("attrs.functional_sub_group")
				}

				this.my_attrs = this.attrs.filter(attr => ! attr.not_real && possible_attrs_keys.has(attr.key))
			}
			else
				this.my_attrs = this.attrs
			
			this.attrs_visible = []
			this.attrs_selected = []
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			this.$emit("clear_attrs_many", { attrs_selected : this.attrs_selected })
		}
	}
}

</script>

